var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"discount-progress-bar",attrs:{"data-external":"discount-progress-bar"}},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"filled",style:({ width: `${_vm.progress}%` })})]),_vm._v(" "),_c('div',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }